module.exports = __webpack_public_path__ + "public/images/graduating-heart.c7e26174eae0544235be2c0015b6f8a9.png";